module.exports = __webpack_public_path__ + "static/media/web-1.351836ab.svg";